
import React from "react";
import { useVersionCheck } from "@kordbooks/shared-versioning";

export interface VersionBannerProps {
    pollMs?: number;
}

export const VersionBanner: React.FC<VersionBannerProps> = ({ pollMs }) => {



    const { isStale } = useVersionCheck(pollMs);




    if (!isStale) return null;

    const handleRefresh = () => {
        // Reload the page so the browser fetches the new index.html and JS bundles.
        window.location.reload();
    };

    return (
        <div className="fixed inset-x-0 top-0 z-1000 bg-amber-500 text-white text-sm px-4 py-2 flex items-center justify-between shadow">
            <span>
                A new version of this app is available. Please refresh.
            </span>
            <button
                type="button"
                onClick={handleRefresh}
                className="ml-4 rounded bg-amber-700 px-3 py-1 text-xs font-medium hover:bg-amber-800"
            >
                Refresh
            </button>
        </div>
    );
};
